import { useAtom } from 'jotai'

import { twoFactorSetupAtom } from '@/state/2fa'

export default function use2Fa() {
  const [twoFactorSetup, setTwoFactorSetup] = useAtom(twoFactorSetupAtom)

  return {
    qrSecret: twoFactorSetup?.secret,
    backupCodes: twoFactorSetup?.backupCodes,
    setTwoFactorSetup,
  }
}
